import { NativeSelect } from "@mui/material";
import { FormizoSchema } from "Components/LabIZO/Formizo";
import { CustomFilterValueProps, FieldType, Filterable, TablizoSchema } from "Components/LabIZO/Tablizo";
import _ from "lodash";

const Table: TablizoSchema[] = [
  {
    label: "Date",
    name: "recTime",
    type: "dateTime",
    transform: "datetime",
    filterable: true,
  },
  {
    label: "Session ID",
    name: "sessionID",
    filterable: true,
  },
  {
    label: "Category",
    name: "category",
    filterable: true,
  },
];

const Info: FormizoSchema[] = [
  {
    label: "Date",
    name: "recTime",
  },
  {
    label: "Session ID",
    name: "sessionID",
  },
  {
    label: "Category",
    name: "category",
  },
];

const Filterables: Filterable[] = [
  {
    label: "Session ID",
    field: "sessionID",
    type: FieldType.text,
  },
  {
    label: "Category",
    field: "category",
    type: FieldType.text,
  },
];

const Export = [
  //TODO:
  {
    label: "Date",
    name: "recTime",
  },
  {
    label: "Session ID",
    name: "sessionID",
  },
  {
    label: "Category",
    name: "category",
  },
];

const AdvFilter: any = [];

const schema: any = {
  Table,
  Info,
  Export,
  AdvFilter,
  Filterables,
};

export default schema;
